import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getUserMarketMapSettings, setUserMarketMapSettings} from 'src/openapi/admin/apis/UsersMarketMapSettingsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SaveOptions} from 'src/components/save-with-reason/save-with-reason-button';
import type {MarketMapSettings} from 'src/openapi/admin/models/MarketMapSettings';

type Props = {
    userId: number,
};

export const useMarketMapsSettings = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getUserMarketMapSettings({userId}),
    ), [userId, apiDispatch]);

    const saveDispatchAction = useCallback((
        marketMapSettings: MarketMapSettings,
        signal: AbortSignal,
        options?: SaveOptions,
    ) => apiDispatch(
        setUserMarketMapSettings({
            userId,
            userMarketMapSettingsSaveRequest: {...marketMapSettings, reason: options?.reason},
        }, {signal}),
    ), [userId, apiDispatch]);

    return useCommonDataHook({
        initValue: {
            createMarketMapAllowed: false,
        },
        getDispatchAction,
        saveDispatchAction,
    });
};
